<script lang="ts" setup>   
    import '../../css/choice.css';
    import {onMounted,reactive,watch} from 'vue';
    import {GetFdbDisclaimer,IMedInformationInput,IFdbDisclaimer,medInformationType,disclaimrMonographType,IPatientRxDemographics,printClass,errorReturnMessage} from '../lib/Models/InteractionModel'; 

    const formData = reactive <
    {   
        medRetrieved: boolean, 
        patientData? : IPatientRxDemographics,
        disclaimerList? : IFdbDisclaimer[],
        medErrorMessage? : string
    }>
    ({     
        medRetrieved : false, 
        medErrorMessage: ""
    });
    onMounted(() => { 
    });
    const props = withDefaults( defineProps<
        {
            showDialog: boolean, 
            patientID: number,
            prescriptionID?: number,
            medicationID?: number,
            displayHeight?: number
        }>(),
        {
            showDialog: false,
            patientID: 0,
            prescriptionID: 0,
            medicationID: 0,
            displayHeight: 100
        });

    watch(() => props.showDialog, (newShow,oldShow) => { 
        if ((newShow) && (newShow !== oldShow) && (!formData.medRetrieved)) { 
            getDisclaimer();
        }
    });

    const emit=defineEmits(["updateModalDisclaimer"]);  

    async function getDisclaimer() : Promise<void> { 
        const medInputs : IMedInformationInput = {InformationType: medInformationType.Disclaimer, PatientID: props.patientID, PrescriptionID: props.prescriptionID, MedID: props.medicationID};
        const respGet = await GetFdbDisclaimer(medInputs); 
        if (!respGet.success) {  
            formData.medErrorMessage = respGet.error?.error ?? errorReturnMessage.disclaimer; 
            emit('updateModalDisclaimer',false,formData.patientData,"");  
            return;
        } 
        formData.medRetrieved = true; 
        formData.disclaimerList = respGet.success.disclaimerList; 
        formData.patientData = respGet.success.patientData; 
        const report_data1 = getPatientData();
        const report_data2 = formData.disclaimerList.map(item => getDisclaimerData(item.monographType, item.monograph)).join("");
        emit('updateModalDisclaimer',true,report_data1,report_data2); 
    } 
    function getPatientData() : string {
        let patient_data = "";
        if (!formData.patientData) {
            return "";
        }
        patient_data =
            `<div style="${printClass.recordTitle}">Patient</div>` +
            `<div style="${printClass.patientData}">Name: ${formData.patientData.fullName}</div>` +
            `<div style="${printClass.patientData}">BirthDate: ${formData.patientData.age} ${formData.patientData.gender}</div>` +
            `<div style="${printClass.patientData}">${formData.patientData.streetAddress}</div>` +
            `<div style="${printClass.patientData}">${formData.patientData.address}</div>` +
            `<div style="${printClass.patientData}">Phone: ${formData.patientData.homePhone}</div>`;
        return patient_data;
    }
    function getDisclaimerData(monograph_type: string, monograph: string) : string {
        let disclaimer_report_data = "";

        switch (monograph_type) {
            case disclaimrMonographType.Important.toString():
                disclaimer_report_data = `<div style="${printClass.mutedTitle}">${monograph}</div>`;
                break;
            case disclaimrMonographType.Break.toString():
                disclaimer_report_data = "<br />";
                break;
            default:
                disclaimer_report_data = `<div style="${printClass.muted}">${monograph}</div>`;
        }
        return disclaimer_report_data;  
    }
</script> 

<template> 
    <div class="row pt-2"> 
        <div v-if="formData.medErrorMessage" class="col"> 
            {{ formData.medErrorMessage }}
        </div>
        <div v-if="!formData.medErrorMessage" class="col"> 
            <div class="row"> 
                <div class="col skinnyscroll " :style="{'overflow-y': 'scroll', 'overflow-x': 'hidden', 'height': (props.displayHeight + 'px')}"> 
                    <div v-for="disclaimerRecord in formData.disclaimerList"> 
                        <div> 
                            <div v-if="disclaimerRecord.monographType === disclaimrMonographType.Important" class="fw-bold text-muted">{{disclaimerRecord.monograph}}</div>
                            <div v-if="disclaimerRecord.monographType === disclaimrMonographType.Notes" class="text-muted">{{disclaimerRecord.monograph}}</div>
                            <div v-if="disclaimerRecord.monographType === disclaimrMonographType.InformationCopyright" class="text-muted">{{disclaimerRecord.monograph}}</div>
                            <br v-if="disclaimerRecord.monographType === disclaimrMonographType.Break" class="text-muted" />
                        </div>
                    </div>  
                </div>
            </div>
        </div>
    </div>
</template>